module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "pagebottom"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [_c('img', {
    staticClass: "bussinessLogo",
    attrs: {
      "src": require("../assets/logo2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-mid"
  }, [_c('ul', [_c('li', [_vm._v("首页")]), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_vm._v("产品")]), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_vm._v("案例")]), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_vm._v("商务方式")]), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_vm._v("关于我们")]), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_vm._v("加入我们")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("广州好酷信息科技有限公司")]), _vm._v(" "), _c('span', [_vm._v("联系电话：020-39106900")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系地址：广州番禺区番禺大道北555号番禺节能科技园创新大厦618")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("展厅地址：广州番禺迎新东路星力动漫游戏产业园J128")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n            版权所有：Copyright 2016 - 2020 好酷科技. All Rights Reserved |\n            "), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备16091001号")])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('img', {
    staticClass: "Code",
    attrs: {
      "src": require("../assets/n.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("微信公众号")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16754d74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 274
// module chunks = 1